import React, { useState } from "react";
import {
	TextField,
	Modal,
	Fade,
	Button
} from "@material-ui/core";
import MultiSelectTable from "components/Table/MultiSelectTable/MultiSelectTable";
import styles from "Styles.module.scss";
import PropTypes from "prop-types";

const MultiSelect = (props) => {

	const [openModal, setOpenModal] = useState(false);
	const handleModal = () => {
		setOpenModal(!openModal);
	};
	const handleSelect = (selected) => {
		props.onChange(selected, props.name);
	};


	return (
		<>

			<div onClick={(e)=>(console.log(e),setOpenModal(true))} style={{color:"rgba(0, 0, 0, 0.38)", borderBottom:"rgba(0, 0, 0, 0.38) dotted 1px", padding:"5px 0 5px 0"}}>
				{props.value ? `${props.value?.length} seleccionados`:"Seleccionar"}
			</div>

        
			<Modal open={openModal} onClose={handleModal} className={styles.modal}>
				<Fade in={openModal}>
					<div style={{width:"90%"}} className={styles.paper}>
				
						<MultiSelectTable 
							options={{ filter: true }} 
							selected={props.value}
							type={props.datatype}
							onChange={handleSelect} 
							columns={props.columns} 
							filters={props.filters}
						/>
						<Button variant="contained" color="primary" style={{float:"right"}} onClick={handleModal}>Seleccionar</Button>
					</div>
				</Fade>
			</Modal>
		</>
	);
};

export default MultiSelect;

MultiSelect.propTypes = {
	onChange: PropTypes.func,
	name: PropTypes.string,
	value: PropTypes.array,
	datatype: PropTypes.object,
	columns: PropTypes.array,
	filters: PropTypes.array
};